import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';

import { Icon } from '../../../design-system';
import { TITLE_SOCIAL_LINKS } from '../locale';
import { CmsLink } from '../../cms/types';
import { getFormatedLinkForReactRouterLink } from '../../TopTen/utils';
import { breakpoints, colors, theme } from '../../../design-system/systemprovider';
import { durations } from '../../common/constants';

const StyledSocialLinksContainer = styled.div`
  display: grid;
  grid-gap: ${theme.space.m};
  margin-bottom: ${theme.space.m};
  justify-content: center;

  @media (min-width: ${breakpoints.M}px) {
    margin-bottom: 0;
    justify-content: initial;
  }

  .social-link-title {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 600;
    color: ${colors.BLACK};
    text-transform: uppercase;
    display: none;

    @media (min-width: ${breakpoints.M}px) {
      display: block;
    }
  }

  .social-link-wrapper {
    display: grid;
    grid-auto-flow: column;
    grid-gap: ${theme.space.xxl};
    justify-content: left;

    @media (min-width: ${breakpoints.M}px) {
      grid-gap: ${theme.space.m};
    }
  }

  .social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 4px;
    border: 1px solid ${colors.BLACK};
    transition: background-color ${durations.ENTER}ms ease-in-out;

    @media (hover: hover) {
      &:hover {
        background-color: ${colors.BACKGROUND};
      }
    }
  }
`;

type Props = {
  links: {
    icon?: string;
    link?: CmsLink;
  }[];
};

export const SocialLinks = ({ links }: Props) => (
  <StyledSocialLinksContainer>
    <h4 className="social-link-title">{TITLE_SOCIAL_LINKS}</h4>
    <div className="social-link-wrapper">
      {links?.map((link, index) => (
        <Link
          key={link?.link?.url}
          className="social-link"
          data-testid={`footer-social-links-${index}`}
          id={`footer-social-links-${index}`}
          to={getFormatedLinkForReactRouterLink(link?.link?.url)}
          target={link?.link?.target ?? '_self'}
          aria-label={`Lien vers la page ${link?.link?.url ?? 'actuelle'}`}
        >
          <Icon name={link?.icon ?? ''} size={32} />
        </Link>
      ))}
    </div>
  </StyledSocialLinksContainer>
);
